module.exports = __webpack_public_path__ + "img/9788925534602.f57d0ee7.jpg";